var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnSignOut = function SvgIcnSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.444 21H5.556C4.7 21 4 20.11 4 19V5c0-.53.164-1.04.456-1.414.291-.375.687-.586 1.1-.586h10.888c.413 0 .809.21 1.1.586C17.836 3.96 18 4.47 18 5v.722a.778.778 0 1 1-1.556 0V5H5.556v14h10.888v-.722a.778.778 0 0 1 1.556 0V19c0 1.11-.692 2-1.556 2Zm-.75-4.884a.871.871 0 0 1 0-1.071L17.291 13H10.77a1 1 0 1 1 0-2h6.521l-1.598-2.055a.869.869 0 0 1 1.371-1.066l2.729 3.507a1 1 0 0 1 0 1.228l-2.724 3.502a.871.871 0 0 1-1.375 0Z",
    fill: "#292525"
  })));
};
export default SvgIcnSignOut;